export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إذا كنت ترى هذا، لم يتم استلام النموذج (ولكن يجب ألا تراه)"])}
}